/**
 * Swagger Interface
 * 数据交换格式: JSON
 *
 * OpenAPI spec version: v2.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
 * voteCommentVO
 */
export type ParamsBodyvoteCommentUsingPost = models.VoteCommentVO;
/**
 * @description voteCommentVoteQuestionIdHotUsingGet参数
 * @property `voteQuestionId` 投票问题ID
 */
export interface ParamsvoteCommentVoteQuestionIdHotUsingGet {
  // pathParams
  /**
   * 投票问题ID
   */
  voteQuestionId: number;
}
/**
 * @description voteCommentVoteQuestionIdUsingGet参数
 * @property `voteQuestionId` 投票问题ID
 * @property `[orderBy]` 排序方式, 0正序-最早优先 1倒序-最新优先
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 */
export interface ParamsvoteCommentVoteQuestionIdUsingGet {
  // pathParams
  /**
   * 投票问题ID
   */
  voteQuestionId: number;
  // queryParams
  /**
   * 排序方式, 0正序-最早优先 1倒序-最新优先
   */
  orderBy?: number;
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * @description voteDeleteUsingGet参数
 * @property `voteQuestionId` 投票问题id
 */
export interface ParamsvoteDeleteUsingGet {
  // queryParams
  /**
   * 投票问题id
   */
  voteQuestionId: number;
}
/**
 * @description voteFollowVoteQuestionIdUsingPost参数
 * @property `voteQuestionId` 投票问题的id
 * @property `type` true关注 false取消关注
 */
export interface ParamsvoteFollowVoteQuestionIdUsingPost {
  // pathParams
  /**
   * 投票问题的id
   */
  voteQuestionId: number;
  // queryParams
  /**
   * true关注 false取消关注
   */
  type: boolean;
}
/**
 * @description voteGetUsingGet参数
 * @property `voteQuestionId` 投票问题的id
 */
export interface ParamsvoteGetUsingGet {
  // queryParams
  /**
   * 投票问题的id
   */
  voteQuestionId: number;
}
/**
 * @description voteListUsingGet参数
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 */
export interface ParamsvoteListUsingGet {
  // queryParams
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * voteQuestionInfo
 */
export type ParamsBodyvoteModifyUsingPost = models.VoteQuestionInfo;
/**
 * @description votePublishUsingPost参数
 * @property `[sendNotice]` sendNotice
 */
export interface ParamsvotePublishUsingPost {
  // queryParams
  /**
   * sendNotice
   */
  sendNotice?: boolean;
}
/**
 * voteQuestionInfo
 */
export type ParamsBodyvotePublishUsingPost = models.VoteQuestionInfo;
/**
 * @description voteVoteQuestionIdUsingPost参数
 * @property `voteQuestionId` 投票问题ID
 * @property `voteOptionId` 选项id
 */
export interface ParamsvoteVoteQuestionIdUsingPost {
  // pathParams
  /**
   * 投票问题ID
   */
  voteQuestionId: number;
  // queryParams
  /**
   * 选项id
   */
  voteOptionId: number;
}
export class VoteApi {
  protected $basePath = '/community/be'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   *
   * @summary 评论

   * @param data: ParamsBodyvoteCommentUsingPost// voteCommentVO
   * @param opt ajax config
   * @returns models.CommonResultCommentInfo
   */
  public voteCommentUsingPost = (
    data: ParamsBodyvoteCommentUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultCommentInfo> => {
    const path = '/api/vote/comment';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.voteCommentVO');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 获取热门评论
   * @param params ParamsvoteCommentVoteQuestionIdHotUsingGet

   * @param opt ajax config
   * @returns models.CommonResultListCommentInfo
   */
  public voteCommentVoteQuestionIdHotUsingGet = (
    params: ParamsvoteCommentVoteQuestionIdHotUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultListCommentInfo> => {
    const path = '/api/vote/comment/{voteQuestionId}/hot';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.voteQuestionId, 'voteQuestionId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 获取评论
   * @param params ParamsvoteCommentVoteQuestionIdUsingGet

   * @param opt ajax config
   * @returns models.CommonResultListCommentInfo
   */
  public voteCommentVoteQuestionIdUsingGet = (
    params: ParamsvoteCommentVoteQuestionIdUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultListCommentInfo> => {
    const path = '/api/vote/comment/{voteQuestionId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('orderBy' in params) p.query.orderBy = params.orderBy;
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    ajax.check(params.voteQuestionId, 'voteQuestionId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 删除投票问题及选项
   * @param params ParamsvoteDeleteUsingGet

   * @param opt ajax config
   * @returns models.CommonResult
   */
  public voteDeleteUsingGet = (
    params: ParamsvoteDeleteUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/vote/delete';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = params;
    ajax.check(params.voteQuestionId, 'voteQuestionId');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 关注投票问题
   * @param params ParamsvoteFollowVoteQuestionIdUsingPost

   * @param opt ajax config
   * @returns models.CommonResult
   */
  public voteFollowVoteQuestionIdUsingPost = (
    params: ParamsvoteFollowVoteQuestionIdUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/vote/follow/{voteQuestionId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('type' in params) p.query.type = params.type;
    ajax.check(params.type, 'type');
    ajax.check(params.voteQuestionId, 'voteQuestionId');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 获取投票问题及选项详情
   * @param params ParamsvoteGetUsingGet

   * @param opt ajax config
   * @returns models.CommonResultVoteQuestionPO
   */
  public voteGetUsingGet = (
    params: ParamsvoteGetUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultVoteQuestionPO> => {
    const path = '/api/vote/get';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('voteQuestionId' in params) p.query.voteQuestionId = params.voteQuestionId;
    ajax.check(params.voteQuestionId, 'voteQuestionId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 获取投票问题列表
   * @param params ParamsvoteListUsingGet

   * @param opt ajax config
   * @returns models.CommonResultPageableResultVoteQuestionSimplePO
   */
  public voteListUsingGet = (
    params: ParamsvoteListUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultVoteQuestionSimplePO> => {
    const path = '/api/vote/list';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 修改投票问题及选项

   * @param data: ParamsBodyvoteModifyUsingPost// voteQuestionInfo
   * @param opt ajax config
   * @returns models.CommonResultVoteQuestionPO
   */
  public voteModifyUsingPost = (
    data: ParamsBodyvoteModifyUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultVoteQuestionPO> => {
    const path = '/api/vote/modify';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.voteQuestionInfo');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 发布投票问题
   * @param params ParamsvotePublishUsingPost
   * @param data: ParamsBodyvotePublishUsingPost// voteQuestionInfo
   * @param opt ajax config
   * @returns models.CommonResultVoteQuestionInfo
   */
  public votePublishUsingPost = (
    params: ParamsvotePublishUsingPost,
    data: ParamsBodyvotePublishUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultVoteQuestionInfo> => {
    const path = '/api/vote/publish';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('sendNotice' in params) p.query.sendNotice = params.sendNotice;
    p.data = data;
    ajax.check(data, 'body.voteQuestionInfo');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 投票
   * @param params ParamsvoteVoteQuestionIdUsingPost

   * @param opt ajax config
   * @returns models.CommonResult
   */
  public voteVoteQuestionIdUsingPost = (
    params: ParamsvoteVoteQuestionIdUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/vote/{voteQuestionId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('voteOptionId' in params) p.query.voteOptionId = params.voteOptionId;
    ajax.check(params.voteOptionId, 'voteOptionId');
    ajax.check(params.voteQuestionId, 'voteQuestionId');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
}

export default new VoteApi();
